// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Ksi-","label":"Radio_label__129gD","checkMark":"Radio_checkMark__2hgLI","disabled":"Radio_disabled__3un4x"};